const ROUTE_PATHS = {
  DASHBOARD: "/",

  // Self Assessment
  SELF_ASSESSMENT: "/self-assessment",
  SELF_ASSESSMENT_RECRUITMENT: "/self-assessment/recruitment",
  SELF_ASSESSMENT_SCREENING: "/self-assessment/screening",
  SELF_ASSESSMENT_TRAINING: "/self-assessment/training",
  SELF_ASSESSMENT_SCHEDULING: "/self-assessment/scheduling",
  SELF_ASSESSMENT_DATA_COLLECTION: "/self-assessment/data-collection",
  SELF_ASSESSMENT_RECOGNITION: "/self-assessment/recognition",
  SELF_ASSESSMENT_COMMUNICATION: "/self-assessment/communication",
  SELF_ASSESSMENT_DATA_SECURITY: "/self-assessment/data-security",
  SELF_ASSESSMENT_SCORECARD: "/self-assessment/scorecard",

  // Volunteer Engagement Strategy
  VOLUNTEER_ENGAGEMENT: "/volunteer-engagement",
  VOLUNTEER_ENGAGEMENT_MISSION_VISION_GOALS:
    "/volunteer-engagement/mission-vision-goals",
  VOLUNTEER_ENGAGEMENT_ROLE_DESIGN_STRUCTURE:
    "/volunteer-engagement/role-design-structure",
  VOLUNTEER_ENGAGEMENT_SCREENING: "/volunteer-engagement/screening",
  VOLUNTEER_ENGAGEMENT_RECRUITMENT_STRATEGY:
    "/volunteer-engagement/recruitment-strategy",
  VOLUNTEER_ENGAGEMENT_ONBOARDING_TRAINING:
    "/volunteer-engagement/onboarding-training",
  VOLUNTEER_ENGAGEMENT_ENGAGEMENT_RETENTION:
    "/volunteer-engagement/engagement-retention",
  VOLUNTEER_ENGAGEMENT_MEASURING_IMPACT:
    "/volunteer-engagement/measuring-impact",
  VOLUNTEER_ENGAGEMENT_FUNDRAISING_PARTNERSHIP:
    "/volunteer-engagement/fundraising-partnership",
  VOLUNTEER_ENGAGEMENT_TECHNOLOGY_AUTOMATION:
    "/volunteer-engagement/technology-automation",
  VOLUNTEER_ENGAGEMENT_FINAL_STRATEGY_REPORT:
    "/volunteer-engagement/final-strategy-report",
};

const PAGE_TITLES = {
  [ROUTE_PATHS.DASHBOARD]: "Dashboard",
  [ROUTE_PATHS.SELF_ASSESSMENT]: "Self Assessment",
  [ROUTE_PATHS.SELF_ASSESSMENT_RECRUITMENT]: "Recruitment",
  [ROUTE_PATHS.SELF_ASSESSMENT_SCREENING]: "Screening",
  [ROUTE_PATHS.SELF_ASSESSMENT_TRAINING]: "Training",
  [ROUTE_PATHS.SELF_ASSESSMENT_SCHEDULING]: "Scheduling",
  [ROUTE_PATHS.SELF_ASSESSMENT_DATA_COLLECTION]: "Data Collection",
  [ROUTE_PATHS.SELF_ASSESSMENT_RECOGNITION]: "Recognition",
  [ROUTE_PATHS.SELF_ASSESSMENT_COMMUNICATION]: "Communication",
  [ROUTE_PATHS.SELF_ASSESSMENT_DATA_SECURITY]: "Data Security",
  [ROUTE_PATHS.SELF_ASSESSMENT_SCORECARD]: "Scorecard",
  [ROUTE_PATHS.VOLUNTEER_ENGAGEMENT]: "Volunteer Engagement Strategy",
  [ROUTE_PATHS.VOLUNTEER_ENGAGEMENT_MISSION_VISION_GOALS]:
    "Mission, Vision, Goals",
  [ROUTE_PATHS.VOLUNTEER_ENGAGEMENT_ROLE_DESIGN_STRUCTURE]:
    "Role Design & Structure",
  [ROUTE_PATHS.VOLUNTEER_ENGAGEMENT_SCREENING]: "Screening",
  [ROUTE_PATHS.VOLUNTEER_ENGAGEMENT_RECRUITMENT_STRATEGY]:
    "Recruitment Strategy",
  [ROUTE_PATHS.VOLUNTEER_ENGAGEMENT_ONBOARDING_TRAINING]:
    "Onboarding & Training",
  [ROUTE_PATHS.VOLUNTEER_ENGAGEMENT_ENGAGEMENT_RETENTION]:
    "Engagement & Retention",
  [ROUTE_PATHS.VOLUNTEER_ENGAGEMENT_MEASURING_IMPACT]:
    "Measuring Impact",
  [ROUTE_PATHS.VOLUNTEER_ENGAGEMENT_FUNDRAISING_PARTNERSHIP]:
    "Fundraising & Partnership",
  [ROUTE_PATHS.VOLUNTEER_ENGAGEMENT_TECHNOLOGY_AUTOMATION]:
    "Technology & Automation",
  [ROUTE_PATHS.VOLUNTEER_ENGAGEMENT_FINAL_STRATEGY_REPORT]:
    "Final Strategy Report",
};

const constants = {
  ROUTE_PATHS,
  PAGE_TITLES,
};

export default constants;
